import { type ReactNode } from "react"
import { View } from "react-native"

export const PreQualContent = ({ children }: { children: ReactNode }) => (
  <View className={"flex-col max-w-[600px] w-full mx-auto justify-start"}>
    {children}
  </View>
)
